import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import Aluno from '../pages/alunos/Alunos';
import Aviso from '../pages/aviso/Aviso';
import Notificacoes from '../pages/notificacoes/Notificacoes';
import Avaliacoes from '../pages/avaliacoes/Avaliacoes';
import Turmas from '../pages/turmas/Turma';
import EditarTurma from '../pages/editarTurma/EditarTurma';
import DadosAlunos from '../pages/dadosalunos/DadosAlunos';
import NotFound from '../pages/notFound/NotFound';
import Suporte from '../pages/suporte/Suporte';
import CalendarioAlunos from '../pages/calendarioAlunos/calendarioAlunos';
import Documentos from '../pages/documentos/Documentos';
import Frequencia from '../pages/frequencias/Frequencias';
import Certificado from '../pages/certificados/Certificados';
import AvaliacaoAluno from "../pages/avaliacoesAluno/AvaliacoesAluno";
import AvaliacaoNovo from '../pages/avaliacaoNovo/AvaliacaoNovo'
import AvaliacaoEspecifica from '../pages/avaliacaoEspecifica/AvaliacaoEspecifica';
import ProtectedRoutePortal from './ProtectedRoute';
import RedirecionamentoInicial from '../components/redirecionamentoinicial/RedirecionamentoInicial';

import { ContextoAutenticacaoProvider } from '../routes/ContextoAutenticação';
import AvaliacaoEditavel from '../pages/avaliacaoEditavel/AvaliacaoEditavel';

function RotasInternas() {

    return (

        <Routes>
            <Route element={<ProtectedRoutePortal />}>

                <Route path="/" element={<RedirecionamentoInicial />} />

                <Route path="/alunos" element={<Aluno />} />
                <Route path="/avisos" element={<Aviso />} />
                <Route path="/notificacoes" element={<Notificacoes />} />
                <Route path="/avaliacoes" element={<Avaliacoes />} />
                <Route path="/turmas" element={<Turmas />} />
                <Route path="/editar/turma" element={<EditarTurma />} />
                <Route path="/informacao" element={<DadosAlunos />} />
                <Route path="/suportes" element={<Suporte />} />
                <Route path="/calendario" element={<CalendarioAlunos />} />
                <Route path="/documentos" element={<Documentos />} />
                <Route path="/frequencias" element={<Frequencia />} />
                <Route path="/certificados" element={<Certificado />} />

                <Route path="avaliacoes/aluno" element={<AvaliacaoAluno />} />
                <Route path="avaliacao/novo" element={<AvaliacaoNovo />} />
                <Route path="avaliacao/aluno" element={<AvaliacaoEspecifica />} />
                <Route path="avaliacao/AvaliacaoEditavel" element={<AvaliacaoEditavel />} />

                <Route path="*" element={<NotFound />} />

            </Route>
        </Routes>
    );
}

function Rotas() {
    return (
        <ContextoAutenticacaoProvider>
            <BrowserRouter>
                <RotasInternas />
            </BrowserRouter>
        </ContextoAutenticacaoProvider>
    );
}

export default Rotas;
